module.exports = __webpack_public_path__ + "static/CoinAll-810a11016c4a557018d4ff15c73773e7.png";